// @flow
import { connect } from 'react-redux';
import ScribeLogin from './ScribeLogin';
import {
  enableAudioMode,
  fetchAsyncBackendIfNeeded,
  fetchAvaWebAppSession,
  fetchBackendSupport,
  fetchFeatureFlag,
  fetchScribeSession,
  fetchScribeSettings,
  fetchTrainingFiles,
  firebaseLoginSuccess,
  getBranchIOData,
  resetConversation,
  startConversationReadClient,
  startRecord,
  switchPlatform,
  toggleDevMode,
} from '../../actions';

const mapStateToProps = state => ({
  avaId: state.scribeSession.avaId,
  backendSupport: state.scribeSession.backendSupport,
  branchId: state.scribeSession.branchId,
  backends: state.scribeSession.backends,
  captioner: state.scribeSession.captioner,
  displayable: state.scribeSession.displayable,
  error: state.scribeSession.error,
  features: state.scribeSession.features,
  scribe: state.scribeConversation.scribe,
  socketConnected: state.scribeSession.socketConnected,
  token: state.scribeConversation.token,
  url: state.scribeSession.url,
});

export default connect(
  mapStateToProps,
  {
    enableAudioMode,
    fetchAsyncBackendIfNeeded,
    fetchAvaWebAppSession,
    fetchBackendSupport,
    fetchFeatureFlag,
    fetchScribeSession,
    fetchScribeSettings,
    fetchTrainingFiles,
    firebaseLoginSuccess,
    getBranchIOData,
    resetConversation,
    startConversationReadClient,
    startRecord,
    switchPlatform,
    toggleDevMode,
  }
)(ScribeLogin);
